import
  React
from 'react';

import
  PropTypes
from 'prop-types';

import {
  Button,
  Text
} from '@vodacom/web-common';

import {
  CustomColors
} from '../../constants';

export const SecondaryButton = props => {

  return (

    <Button
      id={props.id}
      automationId={props.automationId}
      activeBackgroundColor={props.activeBackgroundColor}
      activeBorderColor={props.activeBorderColor}
      activeOpacity={props.activeOpacity}
      activeColor={props.activeColor}
      border={props.border}
      width={props.width}
      maxWidth={props.maxWidth}
      minWidth={props.minWidth}
      height={props.height}
      minHeight={props.minHeight}
      maxHeight={props.maxHeight}
      margin={props.margin}
      padding={props.padding}
      showSpinner={props.showSpinner}
      isEnabled={props.isEnabled}
      onClick={props.onClick}>

      <Text
        color={props.textColor}
        fontSize={props.fontSize}
        textAlign={props.textAlign}
        fontFamily={props.fontFamily}
        fontWeight={props.fontWeight}>

        {props.text}
      </Text>
    </Button>
  );
};

SecondaryButton.propTypes = {
  id: PropTypes.string,
  automationId: PropTypes.string,
  text: PropTypes.string.isRequired,
  height: PropTypes.string,
  minHeight: PropTypes.string,
  maxHeight: PropTypes.string,
  width: PropTypes.string,
  minWidth: PropTypes.string,
  maxWidth: PropTypes.string,
  margin: PropTypes.string,
  padding: PropTypes.string,
  activeBackgroundColor: PropTypes.string,
  activeBorderColor: PropTypes.string,
  activeOpacity: PropTypes.string,
  activeColor: PropTypes.string,
  border: PropTypes.string,
  textColor: PropTypes.string,
  fontSize: PropTypes.string,
  fontWeight: PropTypes.string,
  fontFamily: PropTypes.string,
  textAlign: PropTypes.string,
  onClick: PropTypes.func,
  showSpinner: PropTypes.bool,
  isEnabled: PropTypes.bool
};

SecondaryButton.defaultProps = {
  id: 'unknown-button',
  automationId: 'unknown-button',
  text: PropTypes.string,
  height: '50px',
  minHeight: '50px',
  maxHeight: '50px',
  width: '100%',
  minWidth: '',
  maxWidth: '320px',
  margin: '',
  padding: '',
  activeBackgroundColor: CustomColors.White,
  activeBorderColor: CustomColors.Grey9,
  activeOpacity: '0.25',
  activeColor: CustomColors.Grey9,
  border: '1px solid',
  textColor: CustomColors.Grey9,
  fontSize: '16px',
  fontWeight: 'bold',
  fontFamily: 'Roboto',
  textAlign: 'center',
  onClick: () => {},
  showSpinner: false,
  isEnabled: true
};